const axios = require("axios");

axios.defaults.baseURL = process.env.VUE_APP_BASEAPI;
axios.interceptors.request.use(function(config) {
  config.headers.Authorization = localStorage.getItem("Token") || "";
  config.headers.Lang =
    localStorage.getItem("setlanguage") ||
    localStorage.getItem("detectedLanguage") ||
    "en";
  return config;
});
const state = {
  articles: [],
  techNews: [],
  cultureNews: [],
  remainingNews: [],
};
const getters = {
  getArticles: (state) => state.articles,
  getTechNews: (state) => state.techNews.sort((a, b) => a.Updated - b.Updated),
  getCultureNews: (state) =>
    state.cultureNews.sort((a, b) => a.Updated - b.Updated),
  getRemainingNews: (state) =>
    state.remainingNews.sort((a, b) => a.Score - b.Score),
};

const mutations = {
  insertTechNews(state, payload) {
    state.techNews = payload.articles;
  },
  insertCultureNews(state, payload) {
    state.cultureNews = payload.articles;
  },
  insertRemainingNews(state, payload) {
    state.remainingNews = payload.articles;
  },
};
const actions = {
  parseDate({ commit }, published) {
    //This date is visible outside the cards. Format examples:
    //Less than 24h ago: 20m (if under 60m ago), else 20h
    //This year: Jun 10
    //Longer time ago: Jun 10, 2019
    return new Promise((resolve, reject) => {
      published = new Date(published);
      let now = new Date();
      let diff = now.getTime() - published.getTime();

      let hoursAgo = diff / 3600000;
      if (hoursAgo < 24) {
        let minAgo = diff / 60000;
        if (minAgo < 60) {
          resolve(Math.floor(minAgo) + "m");
        } else {
          resolve(Math.floor(hoursAgo) + "h");
        }
      } else {
        const ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(
          published
        );
        const mo = new Intl.DateTimeFormat("en", { month: "long" }).format(
          published
        );
        const da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(
          published
        );
        if (published.getYear == now.getYear) {
          resolve(mo + " " + da); //e.g. Jul 28
        } else {
          resolve(mo + " " + da + ", " + ye); //e.g. Jul 28, 2019
        }
      }
    });
  },

  GET_FRONTPAGE({ commit }, articleData) {
    return new Promise((resolve, reject) => {
      // console.log(articleData);
      let size = articleData.size;
      let from = articleData.from;
      let isLoggedIn = articleData.isLoggedIn;
      delete articleData.from;
      delete articleData.size;
      // console.log("articledata: ", articleData);
      //User is not logged in and is not searching anything
      if (
        articleData.GeoTags.length == 0 &&
        articleData.Tags.length == 0 &&
        articleData.Search === ""
      ) {
        // console.log("Send to not logged in API");
        axios
          .post(`/frontpage/default/?size=${size}&from=${from}`, articleData)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.log({ err });
            reject(err);
          });
      }
      //Logged in
      else {
        // console.log("Send to logged in API STORE");
        axios
          .post(`/frontpage/custom?size=${size}&from=${from}`, articleData)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.log({ err });
            reject(err);
          });
      }
    });
  },
  GET_FRONTPAGENA({ commit }, articleData) {
    return new Promise((resolve, reject) => {
      let size = articleData.size;
      let from = articleData.from;
      delete articleData.from;
      delete articleData.size;
      let isLoggedIn = articleData.isLoggedIn;
      // console.log(articleData);
      if (
        articleData.GeoTags.length == 0 &&
        articleData.Tags.length == 0 &&
        articleData.Search === ""
      ) {
        // console.log("NA Send to not logged in API");
        axios
          .post(`/frontpage/na/default/?size=${size}&from=${from}`, articleData)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.log({ err });
            reject(err);
          });
      } else {
        // console.log("NA logged in");
        axios
          .post(`/frontpage/custom/na?size=${size}&from=${from}`, articleData)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            // eslint-disable-next-line no-console
            console.log({ err });
            reject(err);
          });
      }
    });
  },
  GET_PUBLIC_ARTICLE({ commit }, articleId) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `article/${articleId}/${localStorage.getItem("setlanguage") ||
            localStorage.getItem("detectedlanguage") ||
            "en"}`
        )
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          // eslint-disable-next-line no-console
          console.log({ err });
          reject(err);
        });
    });
  },
  POST_COMMENT({ commit }, commentData) {
    return new Promise((resolve, reject) => {
      axios
        .post("commentarticle", {
          Articles_id: commentData.Articles_id,
          Content: commentData.Content,
          ArticleComments_id: commentData.ArticleComments_id || null,
        })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  POST_REPORT({ commit }, REPORTDATA) {
    return new Promise((resolve, reject) => {
      axios
        .post("report", REPORTDATA)
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
